import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './vuetify' // Import your Vuetify configuration

const app = createApp(App);
app.use(vuetify);
app.mount('#app');
